import * as React from "react";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Divider } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "12px",
  transition: "0.2s",
  boxShadow: 24,
  height: "auto",
};

export default function VendorFileModal(props) {
  const handleClose = () => {
    props.setDocuments("");
    props.setOtherDocument("");
    props.setOtherFlag(false);
    props.setVendorFileFlag(false);
    props.resetFile();
  };

  return (
    <div>
      <Modal open={props.vendorfileFlag} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              background: "#000",
              borderRadius: "8px 8px 0 0",
              p: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                ml: 2,
                color: "#fff",
              }}
            >
              FILE UPLOAD
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
            }}
          >
            <div
              style={{
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                FILE NAME:{" "}
              </span>
              <span>{props.modalData.filename}</span>
            </div>
            <div>
              <span
                style={{
                  fontWeight: "bold",
                  marginTop: "20px",
                }}
              >
                FILE TYPE:{" "}
              </span>
              <span>
                {props.modalData.filetype
                  ? props.modalData.filetype
                  : props.modalData.otherType}
              </span>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
